import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {o, OdataQuery} from "odata";
import {FilterComponent} from "../filter/filter.component";
import {FilterSettings, FilterOption, FilterUtils} from "../filter";

@Component({
    selector: 'boolean-filter',
    templateUrl: './boolean-filter.component.html'
})
export class BooleanFilterComponent extends FilterComponent {
    
    public SelectedOption: FilterOption;
    
    public Value: boolean = false;
    
    constructor() {
        super();
    }
    
    ngOnInit() {
        if (this.FilterSettings) {
            this.Value = this.FilterSettings.FilterModel;
        }
    }

    updateFilterSettings() {
        this.FilterSettingsChange.emit(new FilterSettings(
            `{0} eq ${this.Value}`,
            this.Value
        ));
    }
}
